<template>
	<div>
		<v-menu
			v-model="menu"
			:close-on-content-click="false"
			transition="scale-transition"
			offset-y
			bottom
			:nudge-bottom="8"
			:nudge-left="10"
			class="background darken-1"
			full-width
			min-width="290px">

			<template v-slot:activator="{ on }">
				<v-text-field
					v-model="formated_datetime"
					:class="dense ? 'grv-input-dense' : 'grv-input'"
					@change="$emit('update:value', $event)"
					append-icon="schedule"
					:name="param.name"
					style="width: 290px"
					readonly
					:rules="rules"
					v-on="on">
					<template v-slot:label>
						<Label :param="param"></Label>
					</template>
				</v-text-field>
			</template>

			<v-card class="background darken-1">
				<v-card-text class="pa-0">
					<v-container grid-list-xs fluid class="pa-0">
						<v-layout row wrap>
							<v-date-picker
								v-model="selected_date"
								color="primary color--text"
								class="background darken-1 elevation-0"
								locale="fr-fr"
								reactive
								@change="updateValue()"
								:readonly="readonly"
								:first-day-of-week="1">
							</v-date-picker>
							<v-time-picker
								v-model="selected_time"
								:readonly="readonly"
								@change="updateValue()"
								color="primary color--text"
								class="background darken-1 elevation-0 time-picker"
								format="24hr">
							</v-time-picker>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary color--text"
						class="text-none"
						@click="menu = false">
						Ok
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu>

		<Hint :param="param"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
const moment = require('moment')
const defaultDate = () => {
	return moment().add(1, 'days').format('YYYY-MM-DD')
}
const defaultTime = () => {
	return moment().format('HH:mm')
}
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	data () {
		return {
			rules: [],
			menu: false,
			selected_date: null,
			selected_time: null,
			formated_datetime: null
		}
	},
	components: {
		Label,
		Hint
	},
	watch: {
		value (val) {
			this.init(val)
		}
	},
	methods: {
		init (val) {
			if (!val) val = moment().add(1, 'days')
			this.selected_date = moment(val).format('YYYY-MM-DD')
			this.selected_time = moment(val).format('HH:mm')
			this.formated_datetime = moment(
				`${this.selected_date}T${this.selected_time}`
			).format('DD-MM-YYYY à HH:mm')
		},
		updateValue () {
			let selected_date = this.selected_date || defaultDate()
			let selected_time = this.selected_time || defaultTime()
			let dateTime = moment(`${selected_date}T${selected_time}`).format()
			this.$emit('update:value', dateTime)
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		this.init(this.value)
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>.v-picker__body
	background: transparent !important

.time-picker
	display: table-cell
	>>>.v-picker__title
		padding-top: 9px
		padding-bottom: 9px
		.v-time-picker-title
			justify-content: center
		.v-time-picker-title__time
			color: var(--v-color-base)
	>>>.v-time-picker-clock
		background: var(--v-background-darken1)
</style>



// WEBPACK FOOTER //
// src/components/fields/datetime.vue